type BranchFieldValues = {
  [key: string]: string | number | boolean,
};

type KnownFieldValues = {
  [key: string]: boolean;
}

type PreFilledFieldValues = {
  [key: string]: string | number | boolean,
};

export default class PersistedProgressiveProfileData {
  /** Field names and values */
  public readonly branchFieldValues: BranchFieldValues;

  /** Field names and values for pre-filling */
  public readonly preFilledFieldValues: BranchFieldValues;

  /** Only field names */
  public readonly knownFieldValues: KnownFieldValues;

  public lastModified: number;

  /** Passed parsed data from `JSON.parse` so can't be relied on at runtime */
  constructor({
    branchFieldValues,
    knownFieldValues,
    preFilledFieldValues,
    lastModified,
  }: {
    branchFieldValues: BranchFieldValues,
    knownFieldValues: KnownFieldValues,
    preFilledFieldValues: PreFilledFieldValues,
    lastModified: number,
  }) {
    this.branchFieldValues = {};
    this.knownFieldValues = {};
    this.preFilledFieldValues = {};
    this.lastModified = (typeof lastModified === 'number') ? lastModified : Date.now();
    try {
      Object.entries(branchFieldValues || {}).forEach(([key, val]) => {
        if (typeof key !== 'string') {
          // eslint-disable-next-line no-console
          console.warn('Invalid Progressive Profile key', key);
          return;
        }
        if (typeof val !== 'string' && typeof val !== 'number' && typeof val !== 'boolean') {
          // eslint-disable-next-line no-console
          console.warn('Invalid Progressive Profile val', val);
          return;
        }
        this.branchFieldValues[key] = val;
      });

      Object.entries(preFilledFieldValues || {}).forEach(([key, val]) => {
        if (typeof key !== 'string') {
          // eslint-disable-next-line no-console
          console.warn('Invalid Progressive Profile key', key);
          return;
        }
        if (typeof val !== 'string' && typeof val !== 'number' && typeof val !== 'boolean') {
          // eslint-disable-next-line no-console
          console.warn('Invalid Progressive Profile val', val);
          return;
        }
        this.preFilledFieldValues[key] = val;
      });

      Object.entries(knownFieldValues || {}).forEach(([key, val]) => {
        if (typeof key !== 'string') {
          // eslint-disable-next-line no-console
          console.warn('Invalid Progressive Profile', key);
          return;
        }
        if (typeof val !== 'boolean') {
          // eslint-disable-next-line no-console
          console.warn('Invalid Progressive Profile val', val);
          return;
        }
        this.knownFieldValues[key] = val;
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Could not parse progressive profile data', e);
    }
  }
}
